var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative chart-wrap"},[_c('highcharts',{ref:_vm.chartId,staticClass:"h-full w-full",attrs:{"options":_vm.options,"id":"chartId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }